<template>
  <v-bottom-sheet v-model="stShowSettings" hide-overlay>
      <v-sheet class="text-right">
        <v-btn 
          icon
          color="primary"
          class="btn-close"
          @click="showSettings"
        >
          <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
        </v-btn>
        <Settings
          v-if="!isChallengeFunctionality"
          :isBookFunctionality="true"
          @close-settings="showSettings"
          />
        <Settings
            v-else
            :isChallengeFunctionality="true"
            @close-settings="showSettings"
        />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Settings from '@/components/core/utils/Settings.vue'

export default {
  data() {
    return {
      bottomSettingsSheet: false,
      isChallengeFunctionality: null
    };
  },
  components: {
    Settings
  },
  methods: {
    ...mapActions('bookReading', [
      'showSettings',
    ]),
  },
  computed: {
    ...mapState({
      stShowSettings: (state) => state.bookReading.mobileTools.showSettings,
    })
  },
  created() {
    this.$root.$on('utilsToggle', (challengeFx) => {
      this.isChallengeFunctionality = challengeFx;
    });
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}

</style>